// Analytics containers
export const ANALYTICS_EVENT_CONTAINER_PRICING_TAB = 'appListingPricingTab';
export const ANALYTICS_EVENT_CONTAINER_SITE_SELECTOR = 'siteSelector'; // Analytics subject ids

export const ANALYTICS_SUBJECT_ID_ADDITIONAL_PRICING_EXAMPLE = 'additionalPricingExample';
export const ANALYTICS_SUBJECT_ID_CONTACT_ADMIN = 'contactAdmin';
export const ANALYTICS_SUBJECT_ID_INSTALL_APP = 'installApp';
export const ANALYTICS_SUBJECT_ID_USER_COUNT = 'inputUserCount'; // Analytics Sources

export const ANALYTICS_EVENT_SOURCE_CONTACT_PARTNER_CLOUD = 'cloud';
export const ANALYTICS_EVENT_SOURCE_CONTACT_PARTNER_DATA_CENTER = 'dataCenter';